module.exports = __webpack_public_path__ + "2e1845152845092dbefa9ccce88acbee.fbx";